const w = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3.74c.41 0 .75.34.75.75v12.95l5.97-5.97a.75.75 0 0 1 1.06 1.06l-7.23 7.23-.02.01-.01.01-.03.03-.02.01A.76.76 0 0 1 12 20a.74.74 0 0 1-.44-.15c-.02 0-.04-.02-.06-.04l-.05-.05-7.24-7.23a.75.75 0 0 1 1.06-1.06l5.98 5.97V4.5c0-.41.34-.75.75-.75Z"/></svg>';
export {
  w
};
